import React from 'react';
import PropTypes from 'prop-types';
import { formatText } from '../../core/i18n';

export const ValidationsList = ({ validationsList, notPassedValidations, valueCompleted }) => {
    const createValidationClass = name => {
        if (notPassedValidations.has(name)) return 'bullet-no-valid';

        return `bullet-${valueCompleted ? 'valid' : ''}`;
    };

    return (
        <ul>
            {validationsList.map(({ name }) => {
                return (
                    <li key={name} className={`modal-bullets bullet ${createValidationClass(name)}`}>
                        {formatText(`signatureKey-validation${name}`)}
                    </li>
                );
            })}
        </ul>
    );
};

ValidationsList.propTypes = {
    notPassedValidations: PropTypes.object,
    validationsList: PropTypes.array,
    valueCompleted: PropTypes.bool,
};
